import type { UseAssetColumnsOptions } from '@/sections/asset/hooks/useAssetColumns';

import {
  ASSET_DEFAULT_COLUMN_ORDER,
  ASSET_IMMUTABLE_COLUMN_IDS,
} from './columns';

/**
 * Derive per-instance column options for the assets table from the
 * `excludeDefaultColumns` prop.
 *
 * - No/empty `excludeDefaultColumns` (main-table path): returns `undefined`, so
 *   `useAssetColumns` falls back to its defaults (storage key `assets.v7`).
 * - With excluded ids (vuln-drawer path): returns a reduced default-active /
 *   immutable set under its own storage key, so excluded columns drop out of the
 *   defaults (but stay selectable in the picker) and the drawer's prefs never
 *   bleed into the main `/assets` table.
 *
 * Pure derivation — behavior matches the previous inline computation in `index.tsx`.
 */
export function deriveColumnOptions(
  excludeDefaultColumns?: string[]
): UseAssetColumnsOptions | undefined {
  if (!excludeDefaultColumns?.length) {
    return undefined;
  }
  return {
    storageKey: 'vulnDrawerAssets.v1',
    activeColumnOrder: ASSET_DEFAULT_COLUMN_ORDER.filter(
      id => !excludeDefaultColumns.includes(id)
    ),
    immutableColumnIds: ASSET_IMMUTABLE_COLUMN_IDS.filter(
      id => !excludeDefaultColumns.includes(id)
    ),
  };
}
